export default __webpack_public_path__ + "static/media/04b0ec336b1dc30b.e3c4e91f31c095989b86658f37ff6782.svg";